<template>
    <div class="col-md-2" style="font-weight: 600; font-size: 14px; font-family: 'Montserrat', sans-serif;">
        <ul class="nav nav-pills flex-column"
            style="width: 40vh; padding-bottom: 10px; padding-top: 10px; list-style-type: none;">
            <li style="padding-bottom: 10px; padding-top: 10px" class="energy-group nav-item">
                <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                   class="ajax" style="font-family: Montserrat, sans-serif; text-transform: uppercase ">
                    <i class="fas fa-plug"></i>
                    <div class="d-inline" style="margin-left: 10px">Energy</div>
                </a>
                <ul class="sub-menu" style="display: none;">
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                           class="ajax"> <i class="fas fa-plug"></i>Awareness &amp; Maintenance</a>
                    </li>
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=515&amp;tier_id=3456"
                           class="ajax">Lighting &amp; Equipment</a>
                    </li>
                </ul>


                <div class="progress" style="height: 1px">
                    <div class="progress-bar progress-background" role="progressbar" aria-valuenow="60"
                         aria-valuemin="0" aria-valuemax="100" style="width: 37%;">
                        <span class="sr-only">37% Complete</span>
                    </div>
                </div>
            </li>
            <li style="padding-bottom: 10px; padding-top: 10px" class="pollution-group  nav-item">
                <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                   class="ajax">
                    <i class="fas fa-cloud"></i>
                    <div class="d-inline"
                         style="margin-left: 10px; font-family: Montserrat, sans-serif; text-transform: uppercase ">
                        Pollution Prevention
                    </div>
                </a>
                <ul class="sub-menu" style="display: none;">
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                           class="ajax">Do the Damn</a>
                    </li>
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=515&amp;tier_id=3456"
                           class="ajax">Get It Poppin</a>
                    </li>
                </ul>


                <div class="progress" style="height: 1px">
                    <div class="progress-bar progress-background" role="progressbar" aria-valuenow="60"
                         aria-valuemin="0" aria-valuemax="100" style="width: 37%;">
                        <span class="sr-only">37% Complete</span>
                    </div>
                </div>
            </li>
            <li style="padding-bottom: 10px; padding-top: 10px" class="solid-waste-group active  nav-item">
                <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                   class="ajax">
                    <i class="fas fa-trash"></i>
                    <div class="d-inline"
                         style="margin-left: 10px; font-family: Montserrat, sans-serif; text-transform: uppercase ">
                        SOLID WASTE
                    </div>
                </a>
                <ul class="sub-menu" style="display: none;">
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                           class="ajax">Divert Waste</a>
                    </li>
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=515&amp;tier_id=3456"
                           class="ajax">Purchasing & Reuse</a>
                    </li>
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=515&amp;tier_id=3456"
                           class="ajax">Reduce Waste</a>
                    </li>
                </ul>


                <div class="progress" style="height: 1px">
                    <div class="progress-bar progress-background" role="progressbar" aria-valuenow="60"
                         aria-valuemin="0" aria-valuemax="100" style="width: 37%;">
                        <span class="sr-only">37% Complete</span>
                    </div>
                </div>
            </li>
            <li style="padding-bottom: 10px; padding-top: 10px" class="transportation-group nav-item">
                <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                   class="ajax" style="font-family: Montserrat, sans-serif; text-transform: uppercase ">
                    <i class="fas fa-plug"></i>
                    <div class="d-inline" style="margin-left: 10px">Transportation</div>
                </a>
                <ul class="sub-menu" style="display: none;">
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                           class="ajax"> <i class="fas fa-plug"></i>Awareness &amp; Maintenance</a>
                    </li>
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=515&amp;tier_id=3456"
                           class="ajax">Lighting &amp; Equipment</a>
                    </li>
                </ul>


                <div class="progress" style="height: 1px">
                    <div class="progress-bar progress-background" role="progressbar" aria-valuenow="60"
                         aria-valuemin="0" aria-valuemax="100" style="width: 37%;">
                        <span class="sr-only">37% Complete</span>
                    </div>
                </div>
            </li>
            <li style="padding-bottom: 10px; padding-top: 10px" class="wastewater-group nav-item">
                <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                   class="ajax" style="font-family: Montserrat, sans-serif; text-transform: uppercase ">
                    <i class="fas fa-recycle"></i>
                    <div class="d-inline" style="margin-left: 10px">Wastewater</div>
                </a>
                <ul class="sub-menu" style="display: none;">
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                           class="ajax"> <i class="fas fa-plug"></i>Awareness &amp; Maintenance</a>
                    </li>
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=515&amp;tier_id=3456"
                           class="ajax">Lighting &amp; Equipment</a>
                    </li>
                </ul>


                <div class="progress" style="height: 1px">
                    <div class="progress-bar progress-background" role="progressbar" aria-valuenow="60"
                         aria-valuemin="0" aria-valuemax="100" style="width: 37%;">
                        <span class="sr-only">37% Complete</span>
                    </div>
                </div>
            </li>
            <li style="padding-bottom: 10px; padding-top: 10px" class="water-group nav-item">
                <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                   class="ajax" style="font-family: Montserrat, sans-serif; text-transform: uppercase ">
                    <i class="fas fa-tint"></i>
                    <div class="d-inline" style="margin-left: 10px">Water</div>
                </a>
                <ul class="sub-menu" style="display: none;">
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                           class="ajax"> <i class="fas fa-plug"></i>Awareness &amp; Maintenance</a>
                    </li>
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=515&amp;tier_id=3456"
                           class="ajax">Lighting &amp; Equipment</a>
                    </li>
                </ul>


                <div class="progress" style="height: 1px">
                    <div class="progress-bar progress-background" role="progressbar" aria-valuenow="60"
                         aria-valuemin="0" aria-valuemax="100" style="width: 37%;">
                        <span class="sr-only">37% Complete</span>
                    </div>
                </div>
            </li>
            <li style="padding-bottom: 10px; padding-top: 10px" class="community-group nav-item">
                <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                   class="ajax" style="font-family: Montserrat, sans-serif; text-transform: uppercase ">
                    <i class="fas fa-hands-helping"></i>
                    <div class="d-inline" style="margin-left: 10px">Community</div>
                </a>
                <ul class="sub-menu" style="display: none;">
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                           class="ajax"> <i class="fas fa-plug"></i>Awareness &amp; Maintenance</a>
                    </li>
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=515&amp;tier_id=3456"
                           class="ajax">Lighting &amp; Equipment</a>
                    </li>
                </ul>


                <div class="progress" style="height: 1px">
                    <div class="progress-bar progress-background" role="progressbar" aria-valuenow="60"
                         aria-valuemin="0" aria-valuemax="100" style="width: 37%;">
                        <span class="sr-only">37% Complete</span>
                    </div>
                </div>
            </li>
            <li style="padding-bottom: 10px; padding-top: 10px" class="print-group nav-item">
                <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                   class="ajax" style="font-family: Montserrat, sans-serif; text-transform: uppercase ">
                    <i class="fas fa-print"></i>
                    <div class="d-inline" style="margin-left: 10px">Print Certified</div>
                </a>
                <ul class="sub-menu" style="display: none;">
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=516&amp;tier_id=3456"
                           class="ajax"> <i class="fas fa-plug"></i>Awareness &amp; Maintenance</a>
                    </li>
                    <li class="">
                        <a href="/user/application/complete-measures?audit_subgroup_id=515&amp;tier_id=3456"
                           class="ajax">Lighting &amp; Equipment</a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        methods: {
            goToMyTeam: function () {
                console.log("Logging in.")
                this.$router.push({path: '/groups'});
            },
            goToAccountInfo: function () {
                console.log("Logging in.")
                this.$router.push({path: '/update-account-info'});
            },
            goToUpdatePassword: function () {
                console.log("Logging in.")
                this.$router.push({path: '/update-password'});
            }
            ,
            goToMySurvey: function () {
                console.log("Logging in.")
                this.$router.push({path: '/survey?surveyId=1'});
            }
        }
    }
</script>

<style scoped>

    .solid-waste-group {
        color: #998a80 !important;
    }

    .energy-group {
        color: #e3a626 !important;
    }

    element.style {
    }

    .tier-info .short-articles {
        margin-bottom: 15px;
        word-wrap: break-word;
        font-size: 16px;
        font-family: "Lato", sans-serif;
        font-weight: 400;
        padding-left: 25px;
        padding-right: 25px;
        padding-bottom: 25px;
        float: left;
        width: 100%;
        border-radius: 4px;
    }

    .background-grey {
        background-color: #f8f8f8;
    }

    .short-articles {
        margin-bottom: 25px;
        word-wrap: break-word;
    }

    .columns-content {
        position: relative;
        border: 1px solid rgb(244, 244, 244);
        -webkit-box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
        -moz-box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
        box-shadow: 0 1px 1px 0 rgba(238, 238, 238, 1);
        padding: 25px 0 0;
        margin-bottom: 30px;
        /* margin: 0 40px 50px; */
        min-height: 100px;
    }

    .clear:after {
        display: block;
        content: '';
        clear: both;
    }

    .full-width .nav-tabs .nav-item {
        margin-bottom: -1px;
        flex-grow: 1;
        text-align: center;
    }

    .full-width .card-header-tabs {
        margin-right: -21px;
        margin-left: -21px;
    }

</style>
